<template>
  <div class="container top-level-div">
    <div class="content-block">
      <div v-if="!blogPost.published">
        <h2 class="mb-5">This post is pending approval.</h2>
      </div>

      <div v-if="$store.getters.isAuthenticated && ($store.getters.isAgent == 'true' || (poster.id == $store.getters.userID))">
        <button class="mylisting-button dark-button mb-3" @click="editPost()">Edit</button>
      </div>

      <img :src="blogPost.hero_image" alt="" width="100%">
      <h1 class="mt-3">{{ blogPost.title }}</h1>
      <p class="mt-3">{{ new Date(blogPost.created_date).toDateString() }}</p>
      <!-- {{ blogPost.created_date }} -->
      <hr>
      <pre v-html="blogPost.content"></pre>
      <!-- <p>{{ blogPost.content }}</p> -->

      <!-- <div v-if="$store.getters.isAgent && $store.getters.isAgent != 'false'"> -->
      <!-- <div v-if="$store.getters.isAuthenticated"> -->
        <!-- Not showing about the author for the ghost poster blogwriter@thrivehire.co -->
        <div v-if="poster.id != 3054">
          <hr>
          <h2>About the Author</h2>
        </div>

        <div class="my-3" v-if="poster.profile_pic != 'https://enginehireio-static-and-media.s3.amazonaws.com/media/profile_pics/default_avatar.jpg'">
          <img :src="poster.profile_pic" style="max-height: 150px;">
        </div>
        <h4>{{ poster.first_name }} {{ poster.last_name }} {{ poster.employer_name }}</h4>
        <!-- <div v-if="poster.is_candidate || poster.is_agent"> -->
          <p>{{ poster.overview }}</p>
          <!-- <p class="mt-3">Get in Touch: {{ poster.email }}</p> -->
        <!-- </div> -->
        <div v-if="poster.is_employer">
          <div class="mt-2 mb-3">
            <a v-if="poster.website" :href="poster.website" target="_blank">
              <img src="../../assets/img/social/website_squircle_charcoal.svg" alt="youtube" class='social-icon'>
            </a>
            <a v-if="poster.youtube" :href="poster.youtube" target="_blank">
              <img src="../../assets/img/social/youtube_squircle_charcoal.svg" alt="youtube" class='social-icon'>
            </a>
            <a v-if="poster.facebook" :href="poster.facebook" target="_blank">
              <img src="../../assets/img/social/facebook_squircle_charcoal.svg" alt="facebook" class='social-icon'>
            </a>
            <a v-if="poster.instagram" :href="poster.instagram" target="_blank">
              <img src="../../assets/img/social/instagram_squircle_charcoal.svg" alt="instagram" class='social-icon'>
            </a>
            <a v-if="poster.twitter" :href="poster.twitter" target="_blank">
              <img src="../../assets/img/social/twitter_squircle_charcoal.svg" alt="twitter" class='social-icon'>
            </a>
            <a v-if="poster.linkedin" :href="poster.linkedin" target="_blank">
              <img src="../../assets/img/social/linkedin_squircle_charcoal.svg" alt="linkedin" class='social-icon'>
            </a>
          </div>
          <pre class="" v-html="poster.about_us"></pre>
        </div>
      <!-- </div> -->
        <!-- More posts from this author -->
        <div v-if="related[0]">
          <hr>
          <h4>More from {{ poster.first_name }} {{ poster.last_name }}</h4>
          <ul>
            <li v-for="article in related" :key="article.id">
              <a :href="article.id">{{ article.title }}</a>
            </li>
          </ul>
        </div>

      <div v-if="postID && blogPost.id">
        <hr>
        <h2>Comments</h2>
        <app-comments :postID="postID" :blogPost="blogPost"></app-comments>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import router from '../../router'

import Comments from './Comments'

export default {
  props: ['id'], // We pass the id in to view blog post from the admin dash
  data() {
    return {
      blogPost: {},
      postID: null,
      poster: {},
      related: [],
    }
  },
  components: {
    appComments: Comments,
  },
  created() {
    if (this.id) {
      this.postID = this.id
    } else {
      this.postID = this.$route.params.id
    }

    this.getPost()
  },
  methods: {
    getPost() {
      axios.get('/api/blogposts/'.concat(this.postID.toString()))
        .then(res => {
          // console.log(res.data)
          this.blogPost = res.data

          //Changes page title to match blog post title
          document.title = this.blogPost.title

          // Need to check if we passed in the id prop, which means we are viewing the post from the admin dash, don't want to re route
          if (!this.id) {
            //Updates the URL to show the blog post title
            this.$router.replace({ name: 'Blog Post', params: {id: this.postID.toString()}, query: {title: this.blogPost.title.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g,' ').split(/\s+/).join('-')} })
          }

          // axios.get('/api/people/'.concat(this.blogPost.poster.toString()))
          axios.get('/api/publicusers/?id='.concat(this.blogPost.poster.toString()))
            .then(res => {
              // console.log('Got blog poster')
              this.poster = res.data[0]

              // Find blog posts using author ID
              axios.get('/api/blogposts/?poster='.concat(this.poster.id.toString()))
                .then(res => {
                  // Empty container to store additional blog post titles
                  let posts = []
                  // A loop to collect every post from the returned data
                  for (let i=0; i < res.data.length; i++) {
                    // Create a new object for every article title found
                    let article = {}
                    article = {
                      title: res.data[i].title,
                      id: res.data[i].id
                    }
                    // Conditional to make sure blogs belong to right organization and is not the current article
                    if (res.data[i].agency_owner === "ThriveHire" && res.data[i].id !== this.blogPost.id) {
                      posts.push(article)
                    }
                  }
                  this.related = posts
                })
                .catch(error => console.log(error))
            })
            .catch(error => console.log(error))
        })
        .catch(error => console.log(error))
    },
    editPost() {
      router.replace({name: 'Edit Blog Post', params: { id: this.blogPost.id } })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/blog/BlogPost.vue